import React from "react";
import { useLang } from "@/context/LanguageContext";
import { hasOrigin, lineageOrigin, originFields } from "@/lib/origins";

export const OriginsSection = ({ person, clan }) => {
  const { t } = useLang();
  const paternal = lineageOrigin(person.paternal_origin, person.father);
  const maternal = lineageOrigin(person.maternal_origin, person.mother);
  const Card = ({ title, origin, primary, children }) => (
    <section className={`heritage-card p-5 ${primary ? "border-l-4 border-l-[#993D22]" : "bg-[#F5F1EA]"}`}>
      <h3 className="font-serif-heritage text-xl text-[#261911] mb-3">{title}</h3>
      {children}
      {hasOrigin(origin) ? (
        <dl className="space-y-2 text-sm">
          {originFields.filter(key => origin?.[key]?.trim()).map(key => (
            <div key={key} className="flex flex-wrap gap-x-2">
              <dt className="text-[#6E5B4F]">{t(`origin_${key}`)} :</dt>
              <dd className="text-[#3A2312]">{origin[key]}</dd>
            </div>
          ))}
        </dl>
      ) : <p className="text-sm italic text-[#6E5B4F]">{t("originUnknown")}</p>}
    </section>
  );
  return (
    <section className="mb-8" data-testid="origins-section">
      <h2 className="label-uppercase text-[#6E5B4F] mb-3">{t("originsTitle")}</h2>
      <p className="text-sm text-[#6E5B4F] mb-4">{t("lineagePriority")}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card title={t("paternalLineage")} origin={paternal} primary>
          {clan && <p className="text-sm font-semibold text-[#993D22] mb-3">{t("paternalClan")} : {clan.name}</p>}
        </Card>
        <Card title={t("maternalLineage")} origin={maternal} />
      </div>
      {hasOrigin(person.origin) && <div className="mt-4"><Card title={t("personalOrigin")} origin={person.origin} /></div>}
      {person.cultural_identity && <p className="mt-4 text-[#3A2312] whitespace-pre-wrap"><span className="font-semibold">{t("culturalIdentity")} : </span>{person.cultural_identity}</p>}
    </section>
  );
};
